import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import dayjs from "dayjs";

import { Section } from "shared/layout";
import Button from "shared/Button";

import Loader from "shared/Loader";
import TabActionBar from "shared/TabActionBar";

export default function DreamStreamOrgSync({
  ibo,
  isCreatingIbo,
  refresh,
  onClose,
  orgSyncData,
  isSyncFinished,
  isSyncStarted,
  onCancel,
  showMarkComplete,
}) {
  const [contact, setContact] = useState(ibo);

  useEffect(() => {
    setContact(ibo);
  }, [ibo]);

  // compare sync start time with current date/time
  let currDateObj = new Date();

  return (
    <div>
      <Section className={styles.section}>
        <TabActionBar>
          <header className={styles.tabActionBarHeader}>
            <h3>
              {contact.iboInfo.name} ({contact.iboInfo.type})
            </h3>
            <div>
              {!isSyncFinished && isSyncStarted && (
                <>
                  {showMarkComplete &&
                    orgSyncData &&
                    orgSyncData.startedOn &&
                    (currDateObj - new Date(orgSyncData.startedOn)) / 60000 >
                      5 && (
                      <>
                        <Button
                          size="small"
                          onClick={() => {
                            onCancel();
                            onClose();
                          }}
                        >
                          Mark Complete
                        </Button>
                      </>
                    )}
                  &nbsp;
                  <Button
                    size="small"
                    onClick={() => {
                      refresh(contact);
                    }}
                  >
                    Refresh
                  </Button>
                </>
              )}
              &nbsp;
              {!isCreatingIbo && (
                <Button size="small" onClick={() => onClose()}>
                  Close
                </Button>
              )}
            </div>
          </header>
        </TabActionBar>
      </Section>

      <Section>
        <div>
          <header>
            {isSyncFinished && !isSyncStarted ? (
              <div>Group Sync is finished.</div>
            ) : !isSyncFinished &&
              isSyncStarted &&
              orgSyncData &&
              orgSyncData.syncTotal > 0 ? (
              <>
                <h3>{orgSyncData.name} in Progress</h3>
                <p>
                  Started{" "}
                  {dayjs(orgSyncData.startedOn)
                    .tz("America/Los_Angeles")
                    .format("MM/DD/YY HH:mm:ss")}
                </p>
              </>
            ) : (
              <div>
                Group Sync will begin shortly. Refresh for latest status.
                <span className={styles.loader2}>
                  <Loader size={50} />
                </span>
              </div>
            )}
          </header>
          {!isSyncFinished &&
            isSyncStarted &&
            orgSyncData &&
            orgSyncData.syncTotal > 0 && (
              <>
                <div className={styles.progress}>
                  <div>
                    {(
                      (orgSyncData.syncCompleted / orgSyncData.syncTotal) *
                      100
                    ).toFixed(2)}
                    %
                  </div>
                  <div>
                    ({orgSyncData.syncCompleted} of {orgSyncData.syncTotal}{" "}
                    syncs completed)
                  </div>
                </div>
                <div className={styles.barContainer}>
                  <div
                    className={styles.bar}
                    style={{
                      width: `${
                        (orgSyncData.syncCompleted / orgSyncData.syncTotal) *
                        100
                      }%`,
                    }}
                  ></div>
                </div>
              </>
            )}
        </div>
      </Section>
    </div>
  );
}
